export default {
    methods:  {
        getCartTotalPrice(cart) {
            if (!cart.length) return 0;

            let total = 0;

            for (let cartItem of cart) {
                total += this.getCartItemTotalPrice(cartItem);
            }

            return this.toCorrectFloat(total);
        },
        getCartItemTotalPrice(cartItem) {
            let total = cartItem.price * cartItem.quantity;

            if (typeof cartItem.deposits === 'undefined') return total;

            for (let deposit of cartItem.deposits) {
                total += deposit.price * cartItem.quantity;
            }

            return this.toCorrectFloat(total);
        },
        toCorrectFloat(number) {
            return parseFloat((Math.round(parseFloat(number) * 100) / 100).toFixed(2));
        }
    },
};
